module.exports = __webpack_public_path__ + "static/media/wMenu.0213c611.png";